import { Command } from 'commander';
import { execSync } from 'node:child_process';
import { isNewerVersion } from '../version.js';
import { NPM_PACKAGE, NPM_VIEW_VERSION_CMD } from '../version-cache.js';
import pkg from '../../package.json' with { type: 'json' };

export const updateCommand = new Command('update')
  .description('Update the Rekor CLI to the latest published version')
  .action(() => {
    console.log(`Current version: ${pkg.version}`);
    console.log('Checking for updates...');
    let latest: string;
    try {
      latest = execSync(NPM_VIEW_VERSION_CMD, { timeout: 10_000 })
        .toString()
        .trim();
    } catch {
      console.error(`Could not reach npm to check for updates.`);
      console.error(`Try manually: npm install -g ${NPM_PACKAGE}`);
      process.exit(1);
    }

    if (!isNewerVersion(latest, pkg.version)) {
      console.log(`Already on the latest version (${pkg.version}).`);
      return;
    }

    console.log(`Updating ${pkg.version} → ${latest}...`);
    try {
      execSync(`npm install -g ${NPM_PACKAGE}@latest`, {
        timeout: 120_000,
        stdio: 'inherit',
      });
      console.log(`Updated to ${latest}.`);
    } catch (err) {
      console.error(`Update failed: ${err instanceof Error ? err.message : String(err)}`);
      console.error(`Try manually: npm install -g ${NPM_PACKAGE}`);
      process.exit(1);
    }
  });
